import React from 'react';
import styled from '@emotion/styled'

import { Grid } from 'style';

const ClientBarComponent = ({ client, role }) => (
  <Grid.Container id="ClientBar">
    <Grid.Row>
      <Text>
        <div>{client}</div>
        <div>{role}</div>
      </Text>
    </Grid.Row>
  </Grid.Container>
);

const Text = styled.div`
    margin-left: 648px;
    padding: 30px 0;
`;

export default ClientBarComponent;
